import Appsignal from "@appsignal/javascript";
import {environment} from "../environments/environment.production";

let appsignalKey: string = environment.appsignalKey;
export const appsignal = new Appsignal({
  key: appsignalKey,
});
